export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
      <rect x="3" y="3" width="58" height="58" rx="18" fill="#D9531E" />
      {/* sunset sky circle */}
      <circle cx="41" cy="22" r="10.5" fill="#E8A838" />
      {/* palm trunk */}
      <path d="M22 52c1.5-8 2.5-15 2-23" stroke="#FAF7F2" strokeWidth="3.4" strokeLinecap="round" fill="none" />
      {/* palm crown */}
      <g stroke="#FAF7F2" strokeWidth="2.6" strokeLinecap="round" fill="none">
        <path d="M24 29c-4.5-1.5-9-1-12.5 2.5" />
        <path d="M24.5 28.5C22 24 18 21.5 13.5 21.5" />
        <path d="M25 28c-1-5 .5-9.5 4-12.5" />
        <path d="M25.5 28.5c2.5-4 6.5-6 11-6" />
        <path d="M25.5 29.5c4-1.5 8.5-1 12 2" />
      </g>
      {/* coconuts */}
      <circle cx="22.5" cy="30.5" r="1.6" fill="#FAF7F2" />
      <circle cx="27" cy="31" r="1.6" fill="#FAF7F2" />
      {/* sea waves */}
      <path d="M10 46c3.4-2.8 6.4-2.8 9.8 0s6.4 2.8 9.8 0 6.4-2.8 9.8 0 6.4 2.8 9.8 0" stroke="#FAF7F2" strokeWidth="2.6" strokeLinecap="round" fill="none" />
      <path d="M14 53.5c3-2.4 5.8-2.4 8.8 0s5.8 2.4 8.8 0 5.8-2.4 8.8 0 5.8 2.4 8.8 0" stroke="#0F626B" strokeWidth="2.6" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export function LogoWordmark({ dark = false, tagline = false }) {
  return (
    <span className="inline-flex flex-col leading-none">
      <span className={`font-serif text-2xl tracking-tight ${dark ? "text-sand" : "text-ink"}`}>
        Villa <span className="italic text-terracotta">Paraiso</span>
      </span>
      {tagline && (
        <span className={`text-[9px] font-mono uppercase tracking-[0.32em] mt-1.5 ${dark ? "text-sand/50" : "text-ink/45"}`}>
          Cabarete · Dominican Republic
        </span>
      )}
    </span>
  );
}
